module.exports = __webpack_public_path__ + "img/IN6×6-Hair-Topper-with-Ombre-Colors-6.766f0b00.jpg";